import React, { FC, useState, useEffect, useCallback } from 'react';
import { Title, useNotify, useRefresh, useTranslate, Notification, useDataProvider, warning, useCreate, useGetManyReference, } from 'react-admin';
import { Button, createStyles, Divider, Grid, makeStyles, TextField, Theme, Tooltip, FormControlLabel, Checkbox, Box, MenuItem, FormHelperText } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useForm, SubmitHandler, useController, Controller } from "react-hook-form";

type Inputs = {
    username: string,
    password: string,
    privilege: string,
    company: string,
};

const Edit: FC = () => {

    const notify = useNotify();
    const dataProvider = useDataProvider();
    const { id } = useParams();
    const refresh = useRefresh();
    const history = useHistory();

    const [username, setUsername] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [retrieveUsername, setRetrieveUsername] = useState<string>("")
    const [usersData, setUsersData] = useState<any>({})

    useEffect(() => {
        dataProvider.getOne(
            'users',
            {
                id: `${id}`,
            },
            {
                onSuccess: async (response) => {
                    setUsersData(response.data)
                    setRetrieveUsername(response.data.username);
                }
            }
        );
    }, [])

    const { register, handleSubmit, control, watch, setValue, formState: { errors, isDirty } } = useForm<Inputs>();
    const OnSubmit = () => {

        const updated = {
            username: username == "" ? retrieveUsername : username,
            privilege: "Admin",
            password: password,
            // company: company,
        }

        dataProvider.update(
            'users',
            {
                id: `${id}`,
                data: updated,
                previousData: {
                    id: `${id}`,

                }
            },
            {
                onSuccess: () => {
                    const timer: ReturnType<typeof setTimeout> = setTimeout(() => refresh(), 1000);
                    notify('Your Server was successfully updated', 'info');
                    history.push("/users");
                },
                onFailure: () => {
                    notify('Error: Your Server was not successfully updated', 'warning');
                }
            },
        )
    }

    return (
        <Box sx={{ pl: 5, pt: 12 }}>
            <Title title="Invite User" />
            <Box>
                <form>
                    <Grid container spacing={1}>
                        <Grid item md={2}>
                            {retrieveUsername &&
                                <TextField
                                    id="Username"
                                    label="Username*"
                                    placeholder="Enter Username"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e: any) => { setUsername(e.target.value) }}
                                    variant="outlined"
                                    fullWidth
                                    type="email"
                                    defaultValue={retrieveUsername}
                                />
                            }
                        </Grid>
                    </Grid>
                    <Box sx={{ pb: 3 }}></Box>
                    <Grid container spacing={2}>
                        <Grid item md={2}>
                            <TextField
                                id="Password"
                                label="Password*"
                                placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                                InputLabelProps={{ shrink: true, required: true }}
                                onChange={(e: any) => { setPassword(e.target.value) }}
                                variant="outlined"
                                fullWidth
                                type="text"
                            />
                            <FormHelperText>Password should not be empty</FormHelperText>
                        </Grid>
                    </Grid>
                    <Box sx={{ p: 4 }}>
                        <Divider />
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item md={3}>
                            <Button
                                type="button"
                                onClick={handleSubmit(OnSubmit)}
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={username == "" || password == "" ? true : false}
                            >
                                Edit
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    )
}

export default Edit;